import { updateGoalViewState, fetchData } from '../../FinancialPlanActions';
import { LIFE, DISABILITY, LONG_TERM_CARE } from '../InsuranceConstants';
import { selectedIndex as selectedOwnerIndex } from '../OwnerDropdown/OwnerDropdownSelector';
import fetchWithDefaults from '../../../CommonUtils/fetchWithDefaults';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { HttpError } from '../../../errors/HttpError';

export const setOpen = (clientId, goalId, subgoalId, isOpen, noteDescription) => dispatch => {
  dispatch(
    updateGoalViewState(goalId, clientId, {
      subgoals: {
        [subgoalId]: {
          noteLoading: false,
          isOpen,
          noteDescription,
        },
      },
    }),
  );
};

export const setLoading = (clientId, goalId, subgoalId, loading) => dispatch => {
  dispatch(
    updateGoalViewState(goalId, clientId, {
      subgoals: {
        [subgoalId]: {
          noteLoading: loading,
        },
      },
    }),
  );
};

export const setDescription = (clientId, goalId, subgoalId, description) => dispatch => {
  dispatch(
    updateGoalViewState(goalId, clientId, {
      subgoals: {
        [subgoalId]: {
          noteDescription: description,
        },
      },
    }),
  );
};

export const saveDescriptionNewWhatIfs = (clientId, goalId, subgoalId, Name, Text) => async (
  dispatch,
  getState,
) => {
  const ownerIndex = selectedOwnerIndex(getState(), { clientId, goalId });
  const IsSpouse = ownerIndex !== 0;

  let InsuranceType;
  switch (subgoalId) {
    case LIFE:
      InsuranceType = 0;
      break;
    case DISABILITY:
      InsuranceType = 1;
      break;
    case LONG_TERM_CARE:
      InsuranceType = 2;
      break;
    default:
  }

  const body = {
    clientId,
    fpId: ADV.consumer.currentFPID(clientId),
    GoalId: goalId,
    InsuranceNoteRecommendation: {
      Text,
      Name,
      InsuranceType,
      IsSpouse,
    },
  };

  try {
    const response = await fetchWithDefaults('/Consumer/UpdatePlanActionSteps/SaveInsuranceNotes', {
      method: 'POST',
      ...httpBodyOptions(body, true),
      showSpinner: true,
    });

    if (response.ok) {
      const { success } = await response.json();

      if (success) {
        dispatch(setLoading(clientId, goalId, subgoalId, false));
        dispatch(setOpen(clientId, goalId, subgoalId, false, ''));
        dispatch(fetchData(ADV.consumer.currentFPID(clientId), clientId, true));
        return;
      }

      // No error state is defined for this component - error handling needs to be improved
      throw new Error('Response status is not success.');
    }

    throw new HttpError(response);
  } catch (err) {
    console.error(err.toString()); // eslint-disable-line no-console

    dispatch(setLoading(clientId, goalId, subgoalId, false));
  }
};

export const saveDescription = (clientId, goalId, subgoalId, name, description) => dispatch => {
  dispatch(saveDescriptionNewWhatIfs(clientId, goalId, subgoalId, name, description));
};
